import { render, staticRenderFns } from "./page-dealer-manage.vue?vue&type=template&id=239d0869&scoped=true&"
import script from "./page-dealer-manage.vue?vue&type=script&lang=js&"
export * from "./page-dealer-manage.vue?vue&type=script&lang=js&"
import style0 from "./page-dealer-manage.vue?vue&type=style&index=0&id=239d0869&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239d0869",
  null
  
)

export default component.exports